import React from 'react';
import PropTypes from 'prop-types';
import GoalSubsection from './GoalSubsection';
import GoalFieldList from '../Fields/GoalFieldList';

const GoalSubsectionFieldlist = ({
  RecordComponent,
  householdId,
  loadedGoals,
  saveGoal,
  removeGoal,
  disableAddButton,
  disableSaveButtons,
  disableDeleteButtons,
  planPrompt,
  readOnly,
  addGoal,
}) => (
  <GoalFieldList
    label=""
    addLabel="Add Goal"
    keyPrefix="goal"
    RecordComponent={RecordComponent}
    childProps={{ householdId }}
    onRemove={goal => removeGoal(goal.id)}
    onSave={goal => saveGoal(goal)}
    directRecords={loadedGoals}
    disableAddButton={disableAddButton}
    disableSaveButtons={disableSaveButtons}
    disableDeleteButtons={disableDeleteButtons}
    planPrompt={planPrompt}
    readOnly={readOnly}
    householdId={householdId}
    onAddNewRecord={addGoal}
  />
);
GoalSubsectionFieldlist.propTypes = {
  RecordComponent: PropTypes.func,
  householdId: PropTypes.string.isRequired,
  saveGoal: PropTypes.func.isRequired,
  removeGoal: PropTypes.func.isRequired,
  loadedGoals: PropTypes.array.isRequired,
  disableSaveButtons: PropTypes.bool,
  disableAddButton: PropTypes.bool,
  disableDeleteButtons: PropTypes.bool,
  planPrompt: PropTypes.string.isRequired,
  readOnly: PropTypes.bool,
  addGoal: PropTypes.func.isRequired,
};

GoalSubsectionFieldlist.defaultProps = {
  RecordComponent: GoalSubsection,
  disableAddButton: false,
  disableSaveButtons: false,
  disableDeleteButtons: false,
  readOnly: false,
};

export default GoalSubsectionFieldlist;
